import Hero from "@/components/site/Hero";
import ClientStrip from "@/components/site/ClientStrip";
import LatestWorks from "@/components/site/LatestWorks";
import AllWorks from "@/components/site/AllWorks";
import Reviews from "@/components/site/Reviews";
import Services from "@/components/site/Services";
import Advantages from "@/components/site/Advantages";
import ChallengeSection from "@/components/site/ChallengeSection";
import ContactSection from "@/components/site/ContactSection";
import PriceCalculator from "@/components/site/PriceCalculator";
import { usePageMeta } from "@/lib/usePageMeta";
import AdvisorStrip from "@/advisor/AdvisorStrip";

export default function Home() {
  usePageMeta(null, "Veb saytlar, mobil tətbiqlər və rəqəmsal həllər. LiveMedia Challenge oyununda xal topla və hədiyyə qutusu qazan!");
  return (
    <div data-testid="home-page">
      <Hero />
      <ClientStrip />
      <LatestWorks />
      <AdvisorStrip />
      <AllWorks />
      <Reviews />
      <Services />
      <PriceCalculator />
      <Advantages />
      <ChallengeSection />
      <ContactSection />
    </div>
  );
}
